import React, { Component } from 'react'
import { Radio, RadioGroup, FormControl, FormControlLabel, FormLabel, TextField, InputLabel, Select, MenuItem, Button, Dialog, DialogContent, DialogActions, Switch, DialogTitle } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Toast from 'react-hot-toast';
import './Precios.css';
import moment from 'moment';

export default class CobroServicios extends Component {

  state = {
    conceptos: [
      { 'id': 1, 'descripcion': 'Normal' },
      { 'id': 2, 'descripcion': 'Nocturna' },
      // { 'id': 3, 'descripcion': '2a Entrega' },
      { 'id': 4, 'descripcion': 'Autoservicio Normal' },
      { 'id': 5, 'descripcion': 'Autoservicio Nocturno' },
      { 'id': 6, 'descripcion': 'Autoservicio Dias Festivos' },
      { 'id': 7, 'descripcion': 'Complemento EAD' },
    ],
    otrosConceptos: [
      { 'id': 1, 'descripcion': 'Local' },
      { 'id': 2, 'descripcion': '2da entrega' },
      { 'id': 3, 'descripcion': 'Complemento de Entrega' },
    ],
    modal_ead: false,
    cita_ead: this.props.citaEAD || {
      tiene_cita: false,
      fecha_ead: null,
      concepto: null,
      descripcion: '',
    }
  }
  componentDidMount = () => {
    this.setState({
      initial_ead: this.props.citaEAD ? {
        ...this.props.citaEAD
      }
        : {
          tiene_cita: false,
          fecha_ead: null,
          concepto: null,
          descripcion: '',
        }
    })
  }

  handleCitaEAD = (key, value) => {
    let { cita_ead } = this.state;
    cita_ead[key] = value;
    if (key === 'tiene_cita' && value == true) {
      cita_ead = {
        ...cita_ead,
        tiene_cita: true,
        fecha_ead: null,
        descripcion: '',
      };
    }
    this.setState({ cita_ead });
  }

  saveCitaEAD = () => {
    const { cita_ead } = this.state;
    let { listaPreciosServicios } = this.props;
    if (cita_ead.tiene_cita) {
      if ([null, ''].includes(cita_ead.fecha_ead)) return Toast.error('La fecha es obligatoria.');
      if (cita_ead.descripcion.length > 256) return Toast.error('La descripcion no puede ser mayor a 256 caracteres.');
    }
    if (isNaN(cita_ead.concepto)) return Toast.error('Es necesario seleccionar un concepto.');
    listaPreciosServicios.especificaciones = listaPreciosServicios.especificaciones.map(esp => {
      if (esp.id_lista_precio_tipo == '3') {
        return {
          ...esp,
          fecha_cita_ead: cita_ead.fecha_ead,
          concepto: cita_ead.concepto
        }
      }
      return esp;
    });
    this.setState({ modal_ead: false, initial_ead: { ...cita_ead } });
    this.props.handleCitaEAD(listaPreciosServicios.especificaciones, cita_ead);
  }

  handleChange = (event, tipo) => {
    let { listaPreciosServicios, inverse } = this.props;
    let especificacionesRemovidas = [];
    if (event.target.value === (inverse ? "si" : "no")) {
      listaPreciosServicios.especificaciones.push({
        id_lista_precio_tipo: tipo.id,
        id_valor_aplicado: 1,
        valor_aplicado: 0,
        id_ref: 0,
        condiciones: [],
      })
    }

    if (event.target.value === (inverse ? "no" : "si")) {
      especificacionesRemovidas = listaPreciosServicios.especificaciones.filter(esp => (esp.id_lista_precio_tipo === tipo.id && esp.id));
      listaPreciosServicios.especificaciones = listaPreciosServicios.especificaciones.filter(esp => esp.id_lista_precio_tipo !== tipo.id);
    }

    this.props.handleOnCobroServicios(listaPreciosServicios, especificacionesRemovidas);
  }

  handleCargoChange = (value, tipo, campo, trigger = true) => {
    let { listaPreciosServicios } = this.props;
    listaPreciosServicios.especificaciones = listaPreciosServicios.especificaciones.map(esp => {
      if (esp.id_lista_precio_tipo === tipo.id) {
        return { ...esp, [campo]: value }
      }
      return esp;
    });
    this.props.handleOnCobroServicios(listaPreciosServicios, trigger);
  }

  handleOnCancelModal = () => {
    this.setState({ modal_ead: false, cita_ead: { ...this.state.initial_ead } });
  }

  render() {
    const { tiposListas, listaPreciosServicios, inverse, fillValue, title, tipoServicios, disableRecoleccion, disableFlete, disableCpac, disabled } = this.props;
    let { conceptos, otrosConceptos, modal_ead = false, cita_ead } = this.state;
    let current_concepto = conceptos.find(c => c.id == cita_ead.concepto)
    current_concepto = current_concepto && current_concepto.descripcion;
    if (tipoServicios && tipoServicios.g_autoservicio && !tipoServicios.g_almacenaje && !tipoServicios.g_completo) {
      conceptos = conceptos.filter(conc => [4, 5, 6].includes(conc.id));
    }
    return (
      <div className='cobro-servicios' style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }} >
        <div style={{ maxWidth: 470 }} >
          <h3 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 10 }}> {title} </h3>
          <div className='servicios row' >
            {
              tiposListas.map((tipo, index) => {
                const especificacion = listaPreciosServicios.especificaciones.find(esp => (esp.id_lista_precio_tipo === tipo.id));
                const radioValue = listaPreciosServicios.especificaciones && especificacion ? (inverse ? "si" : "no") : (inverse ? "no" : "si");
                const disable = ((disableRecoleccion && tipo.id === 1) || (disableFlete && tipo.id === 2) || (disableCpac && tipo.id === 10)) ? true : disabled;
                const edit = (fillValue && [3, 4, 5, 6, 7].includes(tipo.id) && especificacion);
                return (
                  <div
                    key={tipo.id}
                    className={`col-md-auto servicio  ${edit ? 'col-md-12' : 'col-md-6'}`}
                    style={{
                      border: `2px solid ${radioValue === 'si' ? '#f48026' : 'white'}`,
                      justifyContent: 'center'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexWrap: 'wrap',
                    }}>
                      <FormControl
                        component="fieldset"
                        style={{
                          width: edit ? '50%' : '100%',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}   >
                        <FormLabel style={{ color: '#000', fontWeight: 'bold' }} component="legend">{tipo.lpt_nombre}</FormLabel>
                        <RadioGroup
                          aria-label="tipoLista"
                          name="tipoLista"
                          value={radioValue}
                          onChange={(event) => this.handleChange(event, tipo)}>
                          <FormControlLabel style={{ margin: '0px 10px' }} disabled={disable} value="si" control={<Radio />} label="Si" />
                          <FormControlLabel style={{ margin: '0px 10px' }} disabled={disable} value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>
                      {
                        edit && (
                          <>
                            {
                              ( // ENTREGA
                                tipo.id === 3 && (
                                  <div className='col-sm-6' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} >
                                    <Button variant="contained" color="primary" onClick={() => this.setState({ modal_ead: true })} >
                                      Detalles EAD
                                    </Button>
                                    <div>{current_concepto && <div style={{ fontSize: 12, fontWeight: 'bold' }} >
                                      Detalle de entrega: {current_concepto}
                                      <div>{cita_ead.fecha_ead ? moment(cita_ead.fecha_ead).format('DD-MM-YYYY HH:mm') : ''}</div>
                                    </div>}
                                    </div>
                                  </div>
                                ))
                              ||
                              (
                                tipo.id === 4 && (
                                  <div className='col-sm-6' >

                                    <FormControl variant="outlined" className='form-field'>
                                      <InputLabel>Concepto</InputLabel>
                                      <Select
                                        disabled={disabled}
                                        value={especificacion ? (especificacion.concepto || '') : ''}
                                        onChange={(event) => this.handleCargoChange(event.target.value, tipo, 'concepto', false)}
                                      >
                                        {
                                          otrosConceptos.map(concepto => (
                                            <MenuItem value={concepto.id} key={concepto.id}>{concepto.descripcion}</MenuItem>
                                          ))
                                        }
                                      </Select>
                                    </FormControl>
                                  </div>
                                )
                              )
                              ||
                              // OTROS CARGOS X ENTREGA, OTROS CARGOS X RECOLECCION, OTROS CARGOS, SEGURO
                              ([5, 6, 7].includes(tipo.id) && (
                                <>
                                  <div className='col-sm-6' >
                                    <TextField
                                      disabled={disable}
                                      label={tipo.id === 6 ? 'Numero Factura' : 'Concepto'}
                                      onChange={(event) => this.handleCargoChange(event.target.value, tipo, 'concepto', false)}
                                      variant="outlined"
                                      value={especificacion ? especificacion.concepto : ''}
                                      className="form-field"
                                    />
                                  </div>
                                </>
                              ))
                            }
                            {tipo.id !== 3 && (<div className='col-sm-12' >
                              <TextField
                                type="number"
                                inputProps={{
                                  min: "0.000",
                                  step: "0.001",
                                }}
                                disabled={disable}
                                value={especificacion ? especificacion.valor_aplicado : '0'}
                                label={tipo.id === 6 ? 'Valor Asegurado' : 'Importe'}
                                variant="outlined"
                                className="form-field"
                                onChange={(event) => this.handleCargoChange(event.target.value, tipo, 'valor_aplicado', false)}
                                onBlur={(event) => this.handleCargoChange(event.target.value, tipo, 'valor_aplicado')}
                              />
                            </div>)}
                          </>
                        )
                      }
                    </div>
                  </div>
                )
              })
            }
          </div>
          <Dialog
            onClose={this.handleOnCancelModal}
            open={modal_ead}
          >
            <DialogTitle>Detalles de Entrega</DialogTitle>
            <DialogContent style={{ minWidth: 400 }}>
              <div className='col-sm-12' style={{ maxWidth: '100%' }} >
                <FormControlLabel
                  disabled={disabled}
                  control={
                    <Switch
                      checked={!!cita_ead.tiene_cita}
                      onChange={(e) => this.handleCitaEAD("tiene_cita", e.target.checked)}
                      name="g_pending"
                    />
                  }
                  label="Agendar Cita"
                />
              </div>
              {cita_ead.tiene_cita &&
                <div className='col-sm-12' style={{ maxWidth: '100%' }} >
                  <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <FormControl className='form-field'>
                      <KeyboardDatePicker
                        disableToolbar
                        inputVariant="outlined"
                        variant='inline'
                        ampm={false}
                        label={'Fecha Cita EAD'}
                        format="dd/MM/yyyy HH:mm"
                        disablePast
                        disabled={disabled}
                        value={cita_ead.fecha_ead}
                        onChange={(e) => this.handleCitaEAD("fecha_ead", e)}
                      />
                    </FormControl>
                  </MuiPickersUtilsProvider>
                </div>
              }
              <div className='col-sm-4' style={{ maxWidth: '100%' }} >
                <FormControl variant="outlined" className='form-field'>
                  <InputLabel>Detalle de entrega</InputLabel>
                  <Select
                    disabled={disabled}
                    value={cita_ead.concepto}
                    onChange={(e) => this.handleCitaEAD("concepto", e.target.value)}
                  >
                    {
                      conceptos.map(concepto => (
                        <MenuItem value={concepto.id} key={concepto.id}>{concepto.descripcion}</MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </div>
              {cita_ead.tiene_cita &&
                <div className='col-sm-12' style={{ maxWidth: '100%' }} >
                  <FormControl variant="outlined" className='form-field'>
                    <TextField
                      multiline
                      minRows={2}
                      variant="outlined"
                      type={'textarea'}
                      value={cita_ead.descripcion}
                      onChange={(e) => this.handleCitaEAD("descripcion", e.target.value)}
                      label={'Descripción'}
                      disabled={disabled}
                    />
                  </FormControl>
                </div>
              }
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleOnCancelModal}
                color="primary"
              >
                Cancelar
              </Button>
              <Button
                disabled={disabled}
                autoFocus
                onClick={this.saveCitaEAD}
                color="primary"
                variant='contained'
              >
                Guardar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    )
  }
}